<template>
  <header-app back="true" titlepage="یزد گیشه - لیست برنامه ها"></header-app>
  <v-main class="main">
    <div class="col-12 col-md-6 float-right item" v-for="(cat, index)  in program" :key="index">
      <div class="divItem">
        <div>
          <img :src="this.urlUpload+cat.img" width="100%">
        </div>
        <h2>نام برنامه : {{ cat.title }}</h2>
        <v-divider/>
        <h3>دسته بندی : {{ cat.category_name }}</h3>
        <v-divider/>
        <h3>نوع : {{ cat.types_name }}</h3>

        <template v-if="cat.sans_count>0">
          <v-divider/>
          <h3>تعداد کل سانس ها : {{ cat.sans_count }}</h3>
          <v-divider/>
          <h3>تعداد فروش آنلاین : {{ cat.count_sales_online }}</h3>
          <v-divider/>
          <h3>تعداد فروش گیشه : {{ cat.count_sales_gishe }}</h3>
          <v-divider/>
          <h3>تعداد میهمان : {{ cat.count_sales_guset }}</h3>
          <v-divider/>
          <h3>تعداد غیرفعال : {{ cat.count_sales_dis }}</h3>

        </template>
        <div class="btn btn-success" v-if="cat.sans_count>0" @click="click(cat.id)" style="margin: 10px auto">مشاهده
          لیست سانس
        </div>


      </div>
    </div>
  </v-main>
  <footer-app selectedItem="1"></footer-app>
</template>


<script>


import {defineComponent} from "vue";
import HeaderApp from "@/views/headerApp.vue";
import FooterApp from "@/views/FooterApp.vue";
import DataView from "@/views/DataView.vue";
import router from "@/router";
import http from "@/plugins/axios";
import {CurvedBottomNavigation} from "bottom-navigation-vue";
import {th} from "vuetify/locale";

export default {
  name: 'program-view',
  components: {DataView, FooterApp, HeaderApp},
  data: () => ({
    program: [],
    page: 0,
    get_next_page: false,
    urlUpload: "",
    length: 10
  }),
  methods: {
    click(program_id) {
      router.push("/sans/" + program_id)
    },
    getData(pages) {
      const AuthStr = (localStorage.getItem("token"));
      http.post("/getProgram.php", {
            length: this.length,
            start: pages
          },
          {headers: {Token: AuthStr}})
          .then(response => {

            if (response.data != "200") {
              let dataP = response.data;
              this.urlUpload = response.data.urlUpload;
              dataP.massege.forEach((item) => {
                this.program.push(item);
              });
              this.get_next_page = true;
            } else {
              // alert("1");
            }

          });
    },
    fetchNextProducts() {
      window.onscroll = () => {

        let bottomOfWindow = $(window).scrollTop() + $(window).height() - $(document).height();

        if (bottomOfWindow > this.diffFromBottom) {

          // console.log(bottomOfWindow);
          // console.log(this.diffFromBottom);
          if (this.get_next_page) {
            this.get_next_page = false;
            this.page++;
            this.getData(this.page);
          }
        }
      }
    },
  },
  computed: {
    diffFromBottom() {
      let diff = -1200;
      diff = -1900;
      return diff;
    },
  },
  mounted() {
    this.getData();
    this.fetchNextProducts();
  },
}
</script>


<style scoped>
.item {
  padding: 10px;
  text-align: center;
  direction: rtl;
}

.divItem h2 {
  padding-top: 10px;
}

.item .divItem {
  overflow: hidden;
  border-radius: 10px;
  border: 2px solid #e8e8e8;
  background: #e8e8e8;
}
</style>